import React, { useState, useEffect } from "react";
import { AgGridReact } from "ag-grid-react";
import { useNavigate, useParams } from "react-router-dom";

import "ag-grid-community/dist/styles/ag-theme-material.css";
import "ag-grid-community/dist/styles/ag-grid.css";
import { Button, TextField } from "@mui/material";

export default function AgGridPaginatedPageNumberSearchTable({
  columns,
  perPage = 10,
  refreshCounter,
  getTableRows,
  onCellClicked = () => {},
  onSortChanged = () => {},
  // onDocSortChanged = () => {},
  onInputSearch,
}) {
  const params = useParams();
  const [gridApi, setGridApi] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);

  const onGridReady = (params) => {
    setGridApi(params.api);
  };

  const jumpToPage = () => {
    if (!gridApi) return;

    const startIndex = (pageNumber - 1) * perPage;
    gridApi.paginationGoToPage(pageNumber - 1);
    gridApi.ensureIndexVisible(startIndex);
  };

  useEffect(() => {
    if (!gridApi) return;

    const dataSource = {
      getRows: async (params) => {
        gridApi.showLoadingOverlay();
        try {
          const { rows, total, error } = await getTableRows(
            perPage,
            params.endRow - perPage
          );
          gridApi.hideOverlay();
          if (error) {
            params.successCallback([], 0);
            gridApi.showNoRowsOverlay();
          } else {
            params.successCallback(rows, parseInt(total));
            if (rows.length === 0) gridApi.showNoRowsOverlay();
          }
        } catch (error) {
          gridApi.hideOverlay();
          params.successCallback([], 0);
          gridApi.showNoRowsOverlay();
          console.error("Error fetching rows:", error);
        }
      },
    };

    gridApi.setDatasource(dataSource);
  }, [gridApi, refreshCounter, onInputSearch, params.slug]);

  useEffect(() => {
    // Reset page number when dependencies change
    setPageNumber(1);
  }, [refreshCounter, onInputSearch, params.slug]);

  return (
    <div aria-live="polite" aria-busy={false} className="ag-theme-material">
     {params.slug ==="custom" ?  "" :  <div
        style={{ display: "flex", justifyContent: "flex-end", margin: "5px" }}
      >
        <TextField
          variant="outlined"
          style={{}}
          sx={{ pr: 1 }}
          size="small"
          label="Page Number Search"
          type="number"
          min="1"
          value={pageNumber}
          onChange={(e) => setPageNumber(parseInt(e.target.value))}
          onKeyPress={(e) => {
            if (e.key === "Enter") {
              jumpToPage();
            }
          }}
        />
        <Button onClick={jumpToPage}>Search</Button>
      </div>}
      <AgGridReact
        columnDefs={columns}
        onFilterChanged={(params)=>{console.log(params,"params filter")}}
        pagination={true}
        rowModelType="infinite"
        paginationPageSize={perPage}
        cacheBlockSize={perPage}
        onGridReady={onGridReady}
        onSortChanged={onSortChanged}
        // onDocSortChanged={onDocSortChanged}
        domLayout="autoHeight"
        defaultColDef={{
          resizable: true,
          flex: 1,
        }}
        onCellClicked={onCellClicked}
         overlayNoRowsTemplate="<span class='ag-overlay-no-rows-center'>No records to show.</span>"
      />
    </div>
  );
}
